/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */

import { ERROR_MEASURES, ERROR_MEASURE_GROUP } from "./types";
import { showErrorAction } from "../../error/errorActionCreator";
import interpolateString from '../../../utility/stringInterpolation';
import { getMeasureGroups, getMeasures } from "../../../services/policy";
import { IMeasureGroup, IMeasures } from "../../../models/Policies/PolicyContract";
import { getAllMeasureGroupAction, getAllMeasuresAction } from "./measureActionCreator";

export async function getAllMeasures(dispatch: Function) {
  let measures: IMeasures[] = [];
  try {
    measures = await getMeasures();
    if (!measures.length) {
      measures = [];
    }
    dispatch(getAllMeasuresAction(measures));
  } catch (_error) {
    const errorMessage = {
      message: interpolateString([ERROR_MEASURES])
    };
    measures = [];
    dispatch(getAllMeasuresAction(measures));
    dispatch(showErrorAction(errorMessage));
  }
}

export async function getAllMeasureGroup(dispatch: Function) {
  let measureGroup: IMeasureGroup[] = [];
  try {
    measureGroup = await getMeasureGroups();
    if (!measureGroup.length) {
      measureGroup = [];
    }
    dispatch(getAllMeasureGroupAction(measureGroup));
  } catch (_error) {
    const errorMessage = {
      message: interpolateString([ERROR_MEASURE_GROUP])
    };
    measureGroup = [];
    dispatch(getAllMeasureGroupAction(measureGroup));
    dispatch(showErrorAction(errorMessage));
  }
}
